import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20minimalist%20Japanese%20art%20gallery%20interior%20with%20warm%20indirect%20lighting%2C%20cream%20walls%20with%20abstract%20paintings%2C%20wooden%20floor%2C%20serene%20and%20contemplative%20atmosphere%2C%20soft%20beige%20and%20warm%20amber%20tones&width=1600&height=600&seq=sora-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-white" style={{ fontFamily: 'var(--font-heading)' }}>
          每个人的人生都有第二次机会
        </h2>
        <p className="mt-4 text-white/80 leading-relaxed">
          苍井空的故事告诉我们：无论过去如何，每个人都有权利和力量书写自己新的人生篇章。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/category/zhiye-zhuanxing"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解她的转型之路
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}